import {H2, H3, PNoMargin} from '@/typography';
import {SectionPadding} from '@/section';
import Container from '@/container';
import {Row, Col} from '@/grid';
import {withBgOrange50} from '@/hocs/withColors';
import {withUppercase} from '@/hocs/withFontType';
import {GridLayout, GridItem} from '@/ui/grid/grid-layout';
import BoxGrid from '@/ui/box-grid';
import {withMarginBottomDoubleXlToXl, withMarginBottomSm} from '@/hocs/withSpacing';
import {withTextLeftToCenter} from '@/hocs/withAlignment';
import PictureWrapper from '@/ui/images-wrapper';
import Pill from '@/ui/pills';
import {useTranslations} from 'next-intl';
import {DivMargined, FeatureItem, Grid} from '@/content/features/shared';

const imgPath = '/static/images/features/time-and-attendance/';

const Orange50Section = withBgOrange50(SectionPadding);
const RowMargined = withMarginBottomDoubleXlToXl(Row);
const H3Upper = withTextLeftToCenter(withUppercase(withMarginBottomDoubleXlToXl(H3)));
const PillMargined = withMarginBottomSm(Pill);

const TimeAndAttendanceSection = () => {
  const t = useTranslations('features.timeAndAttendance');

  const TimeoffFeaturesArray = t.raw('timeOffAttendance.features') as FeatureItem[];
  const PerformanceManagementFeaturesArray = t.raw(
    'performanceReviews.features'
  ) as FeatureItem[];
  const PayrollFeaturesArray = t.raw('payroll.features') as FeatureItem[];

  return (
    <Orange50Section>
      <Container>
        <Grid fluid>
          <RowMargined center="xs" start="lg" middle="xs">
            <Col xs={12} lg={4}>
              <H2>{t('title')}</H2>
            </Col>
            <Col xs={12} lg={8}>
              <PictureWrapper
                imgPath={imgPath}
                imageUrl="time-and-attendance"
                imageTypeFallback="jpg"
                altImage={t('imageAlt')}
              />
            </Col>
          </RowMargined>

          <DivMargined>
            <H3Upper className="heading-4">
              {t('timeOffAttendance.title')}
            </H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {TimeoffFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--orange100)">
                    {item.pill ? (
                      <PillMargined variant="dotted-green100">Coming soon</PillMargined>
                    ) : null}
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">
              {t('performanceReviews.title')}
            </H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {PerformanceManagementFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--orange100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>

          <DivMargined>
            <H3Upper className="heading-4">{t('payroll.title')}</H3Upper>
            <GridLayout Col={3} lgCol={2} autoRows>
              {PayrollFeaturesArray.map((item, index) => (
                <GridItem key={index}>
                  <BoxGrid backgroundColor="var(--orange100)">
                    <H3>{item.title}</H3>
                    <PNoMargin>{item.copy}</PNoMargin>
                  </BoxGrid>
                </GridItem>
              ))}
            </GridLayout>
          </DivMargined>
        </Grid>
      </Container>
    </Orange50Section>
  );
};

export default TimeAndAttendanceSection;
